<label class="st-field-label">{{ label }}</label>
<textarea [id]="idVal" class="form-control st-input-textarea-field" [placeholder]="placeHolderVal" type="text"
       [ngStyle]="{
          'width': width
       }"
       [rows]="rows"
       [cols]="cols"
       [value]="inputVal"
       [disabled]="disabled"
       [required]="requiredVal"
>

</textarea>
